import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TranslationTrigger = () => {
  const { language } = useLanguage();

  useEffect(() => {
    // Trigger browser translation when language changes
    if (language !== 'English') {
      // Method 1: Use browser's built-in translation API if available
      if (window.google && window.google.translate) {
        try {
          window.google.translate.TranslateElement({
            pageLanguage: 'en',
            includedLanguages: language === '繁體' ? 'zh-TW' : 'zh-CN',
            autoDisplay: true
          });
        } catch (error) {
          console.log('Google Translate API not available');
        }
      }

      // Method 2: Trigger browser translation by changing document properties
      const triggerTranslation = () => {
        // Add a temporary class to force re-render
        document.body.classList.add('translation-active');
        
        // Change document title to trigger translation
        const originalTitle = document.title;
        document.title = `[${language}] ${originalTitle}`;
        
        setTimeout(() => {
          document.title = originalTitle;
          document.body.classList.remove('translation-active');
        }, 500);
      };

      // Method 3: Use meta tags to signal translation needed
      let metaTranslate = document.querySelector('meta[name="google"]');
      if (!metaTranslate) {
        metaTranslate = document.createElement('meta');
        metaTranslate.name = 'google';
        document.head.appendChild(metaTranslate);
      }
      
      // Set content to trigger translation
      metaTranslate.content = 'notranslate';
      setTimeout(() => {
        metaTranslate.content = '';
      }, 300);

      // Execute translation trigger
      triggerTranslation();
    }
  }, [language]);

  // This component doesn't render anything visible
  return null;
};

export default TranslationTrigger; 